
import ebButton from "@/components/FormElements/Button.vue";
import { Vue, Component, Prop } from "vue-property-decorator";

@Component({
  components: {
    ebButton,
  },
})
export default class Create extends Vue {
  private action: any = null;
  private resource: string = "";
  private name: string = "";
  private methods: any[] = [
    {
      label: "GET",
      value: "GET",
    },
    {
      label: "POST",
      value: "POST",
    },
    {
      label: "PUT",
      value: "PUT",
    },
    {
      label: "DELETE",
      value: "DELETE",
    },
  ];

  private createNewPerm() {
    if (this.name != "" && this.action != "" && this.resource !="") {
      this.$emit("newPermission", {
        name: this.name,
        action: this.action.value,
        resource: this.resource,
      });
    } else {
      this.$swal({
            title: "Error",
            text: "Please fill all Fields.",
            type: "error",
          });
    }
  }
}
